import React from "react";

export default function Citations({ refs }) {
  if (!refs || refs.length === 0) return null;
  return (
    <section
      id="references"
      className="mt-16 pt-8 border-t-2 border-[#D4D4D4]"
      data-testid="article-citations"
    >
      <h2 className="font-pixel text-base text-[#0A0A0A] mb-6 uppercase tracking-wide">
        References
      </h2>
      <ol className="space-y-4">
        {refs.map((r) => (
          <li
            key={r.id}
            id={`ref-${r.id}`}
            className="font-terminal text-xs text-[#0A0A0A]/85 leading-relaxed flex gap-3"
          >
            <span className="text-[#15803D] font-bold shrink-0">[{r.id}]</span>
            <span>
              {r.authors}
              {r.year ? ` (${r.year}). ` : ". "}
              <em>{r.title}</em>
              {r.venue ? `. ${r.venue}` : ""}.{" "}
              {r.url && (
                <a
                  href={r.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#15803D] underline underline-offset-2 hover:bg-[#4ADE80]/30 break-all"
                >
                  {r.url}
                </a>
              )}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
